import { useRef, useState } from "react";
import { useDispatch, useSelector, store } from "@/core/redux/store";
import { ISpecificationCategoryResponse } from "@/shared/services/interface/responses/ISpecificationResponse";
import { ISpecificationCategoryCreateRequest } from "@/shared/services/interface/requests/specification";
import { specificationService } from "@/shared/services/api/specification-service";
import { useTranslation } from "react-i18next";
import { setActiveEmptySpecification, setCategories } from "@/core/redux/slices/specification";
import { getCategoryAndItemThunk } from "@/core/redux/thunks/specificationThunk";
import { removeCategoryRecursively } from "@/core/redux/helper/specification";

export default function CollapsibleItemMenuViewModel({
  item,
}: {
  item: ISpecificationCategoryResponse;
}) {
  const specification = useSelector((state) => state.specification);
  const me = useSelector((state: any) => state.user.me);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const allCategories = specification.allCategoryNames;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const editCategoryRef = useRef<HTMLInputElement>(null);

  const handleDeleteCategory = async () => {
    // Redux store'dan güncel categories'i al (closure sorununu önlemek için)
    const currentState = store.getState();
    const currentCategories = currentState.specification.categories;
    
    // Optimistic update: Kategoriyi hemen state'den kaldır
    const updatedCategories = removeCategoryRecursively(
      currentCategories,
      item.id
    );

    // State'i hemen güncelle (setCategories zaten filteredCategories'i de güncelliyor)
    dispatch(setCategories(updatedCategories));
    
    setIsDeleteOpen(false);

    // API çağrısını yap
    const response = await specificationService.deleteSpecificationCategory(
      item.id
    );

    if (!response.success) {
      // Eğer silme başarısız olursa, state'i geri yükle
      if (specification.specification.specification.id && me?.company?.id) {
        dispatch(
          getCategoryAndItemThunk({
            specificationId: specification.specification.specification.id,
            companyId: me.company.id,
          })
        );
      }
    }
    // Başarılı olursa optimistic update zaten yapıldı, ek işlem gerekmez
  };
  const addNewCategory = async (parentId?: string) => {
    const existingCategories = allCategories.filter((name: string) =>
      name.toLowerCase().includes(t("new-category").toLowerCase())
    );

    if (specification.specification.specification.id) {
      let sendData = {
        name:
          existingCategories.length > 0
            ? `${t("new-category")} ${existingCategories.length + 1}`
            : t("new-category"),
        specificationId: specification.specification.specification.id,
      } as ISpecificationCategoryCreateRequest;

      if (parentId) {
        sendData.parentId = parentId;
      }
      const response = await specificationService.createSpecificationCategory(
        sendData
      );

      if (response.success) {
        // Yeni kategori eklendiğinde state'i güncelle
        if (specification.specification.specification.id && me?.company?.id) {
          dispatch(
            getCategoryAndItemThunk({
              specificationId: specification.specification.specification.id,
              companyId: me.company.id,
            })
          );
        }
        
        dispatch(
          setActiveEmptySpecification({
            categoryId: response.data.id,
            isNew: true,
          })
        );
      }
    }
  };
  return {
    editCategoryRef,
    isDeleteOpen,
    setIsDeleteOpen,
    addNewCategory,
    handleDeleteCategory,
  };
}
